<template>
  <div id="container" ref="container">
    <img id="imgCompass" class="compass-img" src="../../assets/three/compass.svg" alt="">
  </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
// import {Face3, Geometry} from "three/examples/jsm/deprecated/Geometry";
import $ from 'jquery'
import '../../tool/jqueryRotate'

export default {
  name: 'three-floor',
  props: {
    roomList: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data () {
    return {
      isFullScreen: false,
      camera: null,
      scene: null,
      renderer: null,
      labelRenderer: null,
      mesh: null,
      controls: null,
      clickObjects: []
    }
  },
  created () {
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 1000)
  },
  methods: {
    init () {
      //  创建场景对象Scene
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color( 0xEFF2FF )

      var light = new THREE.DirectionalLight( 0xffffff, 1.5, );
      light.position.set( 10, 100, 20 ); 			//default; light shining from top
      light.castShadow = true;            // default false
      this.scene.add( light );

      // 楼层地面
      // const texture = new THREE.TextureLoader().load(require('../../assets/three/floor.jpg'))
      const ground = new THREE.Mesh( new THREE.PlaneGeometry(this.$refs.container.clientWidth, this.$refs.container.clientHeight), new THREE.MeshLambertMaterial({ color: 0x777777, side: THREE.DoubleSide }));
      ground.rotation.x = - Math.PI / 2;
      ground.receiveShadow = true;
      this.scene.add( ground );
      this.clickObjects.push(ground)

      // 房间
      let h = 20 * this.$refs.container.clientWidth / 600
      let deepNum = 2 * this.$refs.container.clientWidth / 600

      this.roomList.map(room => {
        if (room.roomNumber !== '未分配') {
          let lineColor = room.rentStatus === '0' ? '#9A9A48': (room.rentStatus === '1' ? '#18887B': (room.rentStatus === '2' ? '#364BA2': (room.rentStatus === '4' ? '#50B5FF': (room.rentStatus === '5' ? '#E56000': (room.rentStatus === '6' ? '#F29324': (room.rentStatus === '7' ? '#5E41FE': (room.rentStatus === '8' ? '#8B36EF': (room.rentStatus === '9' ? '#FC5A5A': (room.rentStatus === '10' ? '#1FB6CB': (room.rentStatus === '11' ? '#5A844A': '#cccccc'))))))))))

          const lineMaterial = new THREE.LineBasicMaterial( { color: lineColor } );
          let pointFront1 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2 + room.high )
          let pointFront2 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2 + room.high )
          let pointFront3 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2 + room.high )
          let pointFront4 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2 + room.high )
          let pointBack1 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2 )
          let pointBack2 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2 )
          let pointBack3 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2 )
          let pointBack4 = new THREE.Vector3( room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2 )

          let lineList1 = [pointFront1, pointFront2, pointFront3, pointFront4, pointFront1]
          let lineList2 = [pointBack1, pointBack2, pointBack3, pointBack4, pointBack1]

          let lineList3 = [pointFront1, pointBack1]
          let lineList4 = [pointFront2, pointBack2]
          let lineList5 = [pointFront3, pointBack3]
          let lineList6 = [pointFront4, pointBack4]

          let lineGeometry1 = new THREE.BufferGeometry().setFromPoints( lineList1 );
          let lineGeometry2 = new THREE.BufferGeometry().setFromPoints( lineList2 );
          let lineGeometry3 = new THREE.BufferGeometry().setFromPoints( lineList3 );
          let lineGeometry4 = new THREE.BufferGeometry().setFromPoints( lineList4 );
          let lineGeometry5 = new THREE.BufferGeometry().setFromPoints( lineList5 );
          let lineGeometry6 = new THREE.BufferGeometry().setFromPoints( lineList6 );
          let line1 = new THREE.Line( lineGeometry1, lineMaterial );
          let line2 = new THREE.Line( lineGeometry2, lineMaterial );
          let line3 = new THREE.Line( lineGeometry3, lineMaterial );
          let line4 = new THREE.Line( lineGeometry4, lineMaterial );
          let line5 = new THREE.Line( lineGeometry5, lineMaterial );
          let line6 = new THREE.Line( lineGeometry6, lineMaterial );
          this.scene.add( line1 );
          this.scene.add( line2 );
          this.scene.add( line3 );
          this.scene.add( line4 );
          this.scene.add( line5 );
          this.scene.add( line6 );

          let planeColor = room.rentStatus === '0' ? '#F8F8E2': (room.rentStatus === '1' ? '#E3F0EE': (room.rentStatus === '2' ? '#CCD2EB': (room.rentStatus === '4' ? '#EAF5FF': (room.rentStatus === '5' ? '#F5EBE4': (room.rentStatus === '6' ? '#FDF3E7': (room.rentStatus === '7' ? '#F0EDFD': (room.rentStatus === '8' ? '#F1E8FC': (room.rentStatus === '9' ? '#FAECEC': (room.rentStatus === '10' ? '#D8EDF0': (room.rentStatus === '11' ? '#E7F4E2': '#D9D9D9'))))))))))

          // // 配置房间的五个面
          // const roomFrontWallGeometry = new THREE.BufferGeometry();
          // const roomRightWallGeometry = new THREE.BufferGeometry();
          // const roomLeftWallGeometry = new THREE.BufferGeometry();
          // const roomBackWallGeometry = new THREE.BufferGeometry();
          // const roomBottomWallGeometry = new THREE.BufferGeometry();
          // const verticesFront = new Float32Array( [
          //   room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2 + room.high,
          // ] );
          // const verticesRight = new Float32Array( [
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2,
          //
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2 + room.high
          // ] );
          // const verticesLeft = new Float32Array( [
          //   room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //
          //   room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2
          // ] );
          // const verticesBack = new Float32Array( [
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 0, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2,
          //
          //   room.x - this.$refs.container.clientWidth / 2, 0, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2, h, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, h, room.y - this.$refs.container.clientHeight / 2,
          // ] );
          // const verticesBottom = new Float32Array( [
          //   room.x - this.$refs.container.clientWidth / 2, 1, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2, 1, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 1, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 1, room.y - this.$refs.container.clientHeight / 2 + room.high,
          //   room.x - this.$refs.container.clientWidth / 2 + room.width, 1, room.y - this.$refs.container.clientHeight / 2,
          //   room.x - this.$refs.container.clientWidth / 2, 1, room.y - this.$refs.container.clientHeight / 2
          // ] );
          //
          // roomFrontWallGeometry.setAttribute( 'position', new THREE.BufferAttribute( verticesFront, 3 ) );
          // roomRightWallGeometry.setAttribute( 'position', new THREE.BufferAttribute( verticesRight, 3 ) );
          // roomLeftWallGeometry.setAttribute( 'position', new THREE.BufferAttribute( verticesLeft, 3 ) );
          // roomBackWallGeometry.setAttribute( 'position', new THREE.BufferAttribute( verticesBack, 3 ) );
          // roomBottomWallGeometry.setAttribute( 'position', new THREE.BufferAttribute( verticesBottom, 3 ) );
          //
          // const roomWallMaterial = new THREE.MeshBasicMaterial( { color: planeColor, side: THREE.DoubleSide } );
          //
          // const frontWall = new THREE.Mesh( roomFrontWallGeometry, roomWallMaterial );
          // const rightWall = new THREE.Mesh( roomRightWallGeometry, roomWallMaterial );
          // const leftWall = new THREE.Mesh( roomLeftWallGeometry, roomWallMaterial );
          // const backWall = new THREE.Mesh( roomBackWallGeometry, roomWallMaterial );
          // const bottomWall = new THREE.Mesh( roomBottomWallGeometry, roomWallMaterial );
          //
          // frontWall.receiveShadow = true;
          // rightWall.receiveShadow = true;
          // leftWall.receiveShadow = true;
          // backWall.receiveShadow = true;
          // bottomWall.receiveShadow = true;
          //
          // frontWall.name = room.code
          // rightWall.name = room.code
          // leftWall.name = room.code
          // backWall.name = room.code
          // bottomWall.name = room.code
          //
          // this.scene.add(frontWall)
          // this.scene.add(rightWall)
          // this.scene.add(leftWall)
          // this.scene.add(backWall)
          // this.scene.add(bottomWall)
          //
          // this.clickObjects.push(frontWall)
          // this.clickObjects.push(leftWall)
          // this.clickObjects.push(leftWall)
          // this.clickObjects.push(backWall)
          // this.clickObjects.push(bottomWall)


          const roomWallBoxMaterial = new THREE.MeshLambertMaterial( { color: lineColor, side: THREE.DoubleSide } );
          const frontWallBox = new THREE.BoxGeometry( room.width, h, deepNum );
          const rightWallBox = new THREE.BoxGeometry( deepNum, h ,room.high );
          const leftWallBox = new THREE.BoxGeometry( deepNum, h ,room.high );
          const backWallBox = new THREE.BoxGeometry( room.width, h, deepNum );
          const bottomWallBox = new THREE.BoxGeometry( room.width, deepNum, room.high );
          let frontWallBoxMesh = new THREE.Mesh( frontWallBox, roomWallBoxMaterial );
          let rightWallBoxMesh = new THREE.Mesh( rightWallBox, roomWallBoxMaterial );
          let leftWallBoxMesh = new THREE.Mesh( leftWallBox, roomWallBoxMaterial );
          let backWallBoxMesh = new THREE.Mesh( backWallBox, roomWallBoxMaterial );
          let bottomWallBoxMesh = new THREE.Mesh( bottomWallBox, roomWallBoxMaterial );
          frontWallBoxMesh.geometry.translate(room.x - this.$refs.container.clientWidth / 2 + room.width / 2, h / 2, room.y - this.$refs.container.clientHeight / 2 + room.high - deepNum / 2)
          rightWallBoxMesh.geometry.translate(room.x - this.$refs.container.clientWidth / 2 + room.width - deepNum / 2, h / 2, room.y - this.$refs.container.clientHeight / 2 + room.high / 2)
          leftWallBoxMesh.geometry.translate(room.x - this.$refs.container.clientWidth / 2 + deepNum / 2, h / 2, room.y - this.$refs.container.clientHeight / 2 + room.high / 2)
          backWallBoxMesh.geometry.translate(room.x - this.$refs.container.clientWidth / 2 + room.width / 2, h / 2, room.y - this.$refs.container.clientHeight / 2 + deepNum / 2)
          bottomWallBoxMesh.geometry.translate(room.x - this.$refs.container.clientWidth / 2 + room.width / 2, 1, room.y - this.$refs.container.clientHeight / 2 + room.high / 2 + deepNum / 2)
          frontWallBoxMesh.castShadow = true;
          rightWallBoxMesh.castShadow = true;
          leftWallBoxMesh.castShadow = true;
          backWallBoxMesh.castShadow = true;
          bottomWallBoxMesh.castShadow = true;

          frontWallBoxMesh.receiveShadow = true;
          rightWallBoxMesh.receiveShadow = true;
          leftWallBoxMesh.receiveShadow = true;
          backWallBoxMesh.receiveShadow = true;
          bottomWallBoxMesh.receiveShadow = true;

          frontWallBoxMesh.name = room.code
          rightWallBoxMesh.name = room.code
          leftWallBoxMesh.name = room.code
          backWallBoxMesh.name = room.code
          bottomWallBoxMesh.name = room.code

          let cubeX = room.x - this.$refs.container.clientWidth / 2 + room.width / 2
          let cubeY = room.y - this.$refs.container.clientHeight / 2 + room.high / 2
          const CUBE_RADIUS = 20;
          const cubeDiv = document.createElement( 'div' );
          cubeDiv.className = 'roomLabel';
          cubeDiv.textContent = `${room.roomNumber}室`;
          const cubeLabel = new CSS2DObject( cubeDiv );
          cubeLabel.position.set( cubeX, CUBE_RADIUS, cubeY );
          bottomWallBoxMesh.add( cubeLabel );

          this.scene.add( frontWallBoxMesh );
          this.scene.add( rightWallBoxMesh );
          this.scene.add( leftWallBoxMesh );
          this.scene.add( backWallBoxMesh );
          this.scene.add( bottomWallBoxMesh );

          this.clickObjects.push(frontWallBoxMesh)
          this.clickObjects.push(rightWallBoxMesh)
          this.clickObjects.push(leftWallBoxMesh)
          this.clickObjects.push(backWallBoxMesh)
          this.clickObjects.push(bottomWallBoxMesh)


          // let geometry = new THREE.BoxGeometry( room.width, h, room.high );
          // let material = new THREE.MeshBasicMaterial( {color: planeColor} );
          // let cube = new THREE.Mesh( geometry, material );
          // cube.name = room.code
          //
          // let cubeX = room.x - this.$refs.container.clientWidth / 2 + room.width / 2
          // let cubeY = room.y - this.$refs.container.clientHeight / 2 + room.high / 2
          // cube.position.set(cubeX, h / 2, cubeY)
          // this.scene.add( cube );

          // const CUBE_RADIUS = 20;
          // const cubeDiv = document.createElement( 'div' );
          // cubeDiv.className = 'roomLabel';
          // cubeDiv.textContent = `${room.roomNumber}室`;
          // const cubeLabel = new CSS2DObject( cubeDiv );
          // cubeLabel.position.set( cubeX, CUBE_RADIUS, cubeY );
          // cube.add( cubeLabel );
          //
          // this.clickObjects.push(cube)
        }
      })


      /**
       * 相机设置
       */
      let container = document.getElementById('container')
      this.camera = new THREE.PerspectiveCamera(90, document.body.clientWidth / document.body.clientHeight, 0.1, 10000)
      this.camera.position.set(0, 200, 300)

      /**
       * 创建渲染器对象
       */
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.shadowMap.enabled = true;
      this.renderer.shadowMapEnabled = true
      container.appendChild(this.renderer.domElement);

      this.labelRenderer = new CSS2DRenderer();
      this.labelRenderer.setSize( container.clientWidth, container.clientHeight);
      this.labelRenderer.domElement.style.position = 'absolute';
      this.labelRenderer.domElement.style.top = '0px';
      container.appendChild( this.labelRenderer.domElement );

      // 创建控件对象
      // this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.controls = new OrbitControls( this.camera, this.labelRenderer.domElement )

      this.animate()

      document.querySelector('#container').addEventListener('click', this.roomClick, true)
    },

    // 动画
    animate () {
      requestAnimationFrame(this.animate)

      var dir = new THREE.Vector3(-this.camera.position.x, 0, -this.camera.position.z).normalize();
      var theta = Math.atan2(-dir.x, -dir.z);
      // $('#imgCompass').rotate(THREE.Math.radToDeg(theta));

      // this.mesh.rotation.x += 0.01
      // this.mesh.rotation.y += 0.02
      this.renderer.render(this.scene, this.camera)
      this.labelRenderer.render( this.scene, this.camera );
    },

    roomClick (event) {
      console.log(event)
      event.preventDefault()
      var raycaster = new THREE.Raycaster()
      var mouse = new THREE.Vector2()

      let containerLeft = this.$refs.container.getBoundingClientRect().left
      let containertop = this.$refs.container.getBoundingClientRect().top

      if (event.touches) {
        mouse.x = (event.touches[0].pageX / this.$refs.container.clientWidth) * 2 - 1
        mouse.y = -(event.touches[0].pageY / this.$refs.container.clientHeight) * 2 + 1
      } else {
        mouse.x = ((event.clientX - containerLeft) / this.$refs.container.clientWidth) * 2 - 1
        mouse.y = -((event.clientY - containertop) / this.$refs.container.clientHeight) * 2 + 1
      }

      raycaster.setFromCamera(mouse, this.camera)

      var intersects = raycaster.intersectObjects(this.clickObjects)
      console.log(intersects)
      if (intersects.length > 0){
        console.log(intersects[0].object.name)
        this.roomList.map(v => {
          if (intersects[0].object.name === v.code) {

            this.$emit("roomClick", v)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
#container {
  position: relative;
  .compass-img {
    width: 64px;
    height: 64px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
}

/deep/ .roomLabel {
  color: #FFF;
  font-family: sans-serif;
  border-radius: 5px;
  padding: 2px;
  background: rgba( 0, 0, 0, .6 );
}
</style>



// WEBPACK FOOTER //
// src/components/Three/threeFloor.vue